import styled from 'styled-components';

export const Dimensions = styled.div`
  pointer-events: none;

  position: absolute;
  bottom: -10px;
  padding: 2px 5px;
  transform: translateY(100%);

  border-radius: 5px;
  background-color: var(--neutral-2);
  color: var(--main-1);
  font-family: 'Inter';
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0 0 5px #000;
`;
